"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueryOrderByEnum = exports.EventQuerySortByEnum = void 0;
var EventQuerySortByEnum;
(function (EventQuerySortByEnum) {
    EventQuerySortByEnum["CreatedAt"] = "createdAt";
    EventQuerySortByEnum["StartsAt"] = "schedule.startsAt";
})(EventQuerySortByEnum = exports.EventQuerySortByEnum || (exports.EventQuerySortByEnum = {}));
;
var EventQueryOrderByEnum;
(function (EventQueryOrderByEnum) {
    EventQueryOrderByEnum[EventQueryOrderByEnum["Ascending"] = 1] = "Ascending";
    EventQueryOrderByEnum[EventQueryOrderByEnum["Descending"] = -1] = "Descending";
})(EventQueryOrderByEnum = exports.EventQueryOrderByEnum || (exports.EventQueryOrderByEnum = {}));
//# sourceMappingURL=IEventQuery.js.map